import React, { useState, useEffect } from 'react';
import PostHeader from '@components/PostHeader';
import PostMobile from '@components/PostMobile';
import '@styles/BlogBody.css';
const Postjavascript4 = () => {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsDesktop(window.innerWidth >= 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // Add Open Graph meta tags for this specific post
  useEffect(() => {
    const updateMetaTag = (property, content, isProperty = true) => {
      const attribute = isProperty ? 'property' : 'name';
      let metaTag = document.querySelector(`meta[${attribute}="${property}"]`);
      
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute(attribute, property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', content);
    };

    const post = {
      title: "JavaScript Promises and Asynchronous Programming",
      date: "December 1, 2023",
      image: "/assets/FeedItems/BBETHMT5fCWQpvNDBTR.svg",
      summary: "Learn about asynchronous programming in JavaScript using promises. Understand the basics of promises, creating and using promises, and the async/await syntax.",
      path: "blog/technology/javascript/post/postjavascript4"
    };

    document.title = `${post.title} - Cloud CZR`;
    updateMetaTag('og:title', `${post.title} - Cloud CZR`);
    updateMetaTag('og:description', post.summary);
    updateMetaTag('og:url', window.location.href);
    updateMetaTag('og:type', 'article');
    updateMetaTag('og:image', `${window.location.origin}${process.env.PUBLIC_URL}${post.image}`);
    updateMetaTag('og:image:alt', 'Cloud CZR, Cloudczr, cloudczr.com');
    
    updateMetaTag('description', post.summary, false);
    updateMetaTag('twitter:title', `${post.title} - Cloud CZR`, false);
    updateMetaTag('twitter:description', post.summary, false);
  }, []);

  const post = {
    title: "JavaScript Promises and Asynchronous Programming",
    date: "December 1, 2023",
    image: "/assets/FeedItems/BBETHMT5fCWQpvNDBTR.svg",
    summary: "Learn about asynchronous programming in JavaScript using promises. Understand the basics of promises, creating and using promises, and the async/await syntax.",
    path: "blog/technology/javascript/post/postjavascript4"
  };
  return (
    <div>
      {isDesktop ? (
        <PostHeader post={post} config={{ width: '400px', height: '400px' }} />
      ) : (
        <PostMobile post={post} config={{ width: '400px', height: '400px' }} />
      )}
      <div class="body-gold">
        <p>
          Asynchronous programming is a key aspect of JavaScript, allowing you to perform tasks without blocking the main thread. Promises are a powerful feature that make it easier to work with asynchronous code.
        </p>
        <h2>Understanding Promises</h2>
        <p>
          A promise is an object that represents the eventual completion (or failure) of an asynchronous operation and its resulting value. Promises provide a cleaner and more manageable way to handle asynchronous code compared to callbacks.
        </p>
        <h2>Creating and Using Promises</h2>
        <p>
          You can create a promise using the Promise constructor. A promise has three states: pending, fulfilled, and rejected. You can use the then and catch methods to handle the resolved and rejected states of a promise.
        </p>
        <h2>Async/Await</h2>
        <p>
          The async/await syntax is a more modern and readable way to work with promises. By using the async keyword before a function, you can use the await keyword to pause the execution of the function until the promise is resolved.
        </p>
        <p>
          Understanding promises and asynchronous programming is essential for writing efficient and responsive JavaScript code. By mastering these concepts, you can handle asynchronous operations more effectively and create better user experiences.
        </p>
      </div>
    </div>
  );
};

export default Postjavascript4;